import { atom } from 'recoil';

export const categoriesAtom = atom({
  key: 'categoriesAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});